import React from 'react';
import { useWhoami } from '@cotera/client/app/stores/org';
import { useInScopeModel } from '../actions/framework';
import { GraphModel } from '../graph/graph.model';
import { trackRecentActivity } from '../components/ui/recent-activity-section';

type UseTrackRecentActivityParams =
  | {
      type: 'dataset' | 'agent' | 'document';
      name: string;
    }
  | {
      type: 'column';
      datasetName: string;
      columnName: string;
    };

/**
 * Hook to automatically track recent activity when viewing a resource.
 * Will only track if the resource exists in the graph.
 */
export const useTrackRecentActivity = (
  params: UseTrackRecentActivityParams
) => {
  const orgId = useWhoami((s) => s.org.id);
  const graphModel = useInScopeModel(GraphModel);
  const graph = graphModel?.graph.snapshot();

  React.useEffect(() => {
    if (graph === undefined || graph === null) {
      return;
    }

    if (params.type === 'column') {
      const { datasetName, columnName } = params;
      const column = graph.getColumn({ rel: datasetName, name: columnName });
      if (column !== null) {
        trackRecentActivity('column', datasetName, orgId, columnName);
      }
    } else {
      const { name } = params;
      if (graph.hasSymbol(name)) {
        trackRecentActivity(params.type, name, orgId);
      }
    }
  }, [params, graph, orgId]);
};
